import * as licensing from '@progress/kendo-licensing';
var allowed = ['localhost', '127.0.0.1', '[::1]', 'telerik.com', 'progress.com', 'stackblitz.io', 'csp.app'];
/**
 * @hidden
 */
export function validatePackage(packageMetadata) {
    if (typeof licensing !== 'undefined') {
        var skip = allowed.some(function (hostname) { var _a; return (_a = globalThis.document) === null || _a === void 0 ? void 0 : _a.location.hostname.endsWith(hostname); });
        return skip || licensing.validatePackage(packageMetadata);
    }
    else {
        var message = "License activation failed for ".concat(packageMetadata.name, "\n");
        message += 'The @progress/kendo-licensing script is not loaded.\n';
        message += "See ".concat(packageMetadata.licensingDocsUrl, " for more information.\n");
        console.warn(message);
        return false;
    }
}
